import * as types from './actionTypes';
import Immutable from 'seamless-immutable';

const initialState = Immutable({
  loading: true,
  story: {},
  related: [],
  featured: [],
  storyById: [],
});

export default function reduce(state = initialState, action = {}) {
  switch (action.type) {
    case types.LOADING:
      return {
        ...state,
        loading: true,
      };
    case types.LOADED:
      return {
        ...state,
        loading: false,
        cities: action.cities,
        story: action.story,
        related: action.related,
        featured: action.featured,
        storyById: action.storyById,
      };
    default:
      return state;
  }
}

//Selectors
export function getValue(state, key) {
  const value = state['story'][key];
  switch (key) {
    default:
      return value;
  }
}

export function getAllValues(state, key) {
  return state['story'];
}
